import axios from '@/axios.js'
const apiUrl = 'https://management.evolugy.com/v1/events';

export default {
    addEvent ({ dispatch, rootState }, payload) {
        return new Promise((resolve, reject) => {
            var config = {
                method: 'post',
                url: apiUrl,
                headers: { 
                        'Authorization': 'Bearer '+rootState.AuthToken
                },
                data: payload
            };
            axios(config)
            .then(function (response) {

                console.log(response.data);
                dispatch('fetchEvents');
                resolve(response);

            })
            .catch(function (error) {
                console.log(error);
                reject(error);
            });
        });
    },
    fetchEvents ({ commit, rootState }) {
        return new Promise((resolve, reject) => {
            var config = {
                method: 'get',
                url: apiUrl+'/?perPage=80&currentPage=1',
                headers: { 
                        'Authorization': 'Bearer '+rootState.AuthToken
                    }
            };

            axios(config)
            .then(function (response) {
                console.log(response.data);

                // filtrar users where type = virtual_consultation or consultation
                var consultations = response.data.data.events.filter(obj => {
                    return (obj.type == "virtual_consultation" && obj.doctor_id == rootState.AppActiveUser.id) 
                    || (obj.type == "consultation" && obj.doctor_id == rootState.AppActiveUser.id) 
                });

                var events = response.data.data.events.filter(obj => {
                    return obj.doctor_id == rootState.AppActiveUser.id
                });
                
                commit('SET_CONSULTATIONS', consultations);

                commit('SET_EVENTS', events);

                resolve(response);

            })
            .catch(function (error) {
                console.log(error);
                reject(error);
            });
        });
    },
    editEvent ({ commit }, payload) {

    }
}